import BaseApi from '~/api/base';
import { keysToCamel } from '~/utils/toCamelCase';
import mockMetadata from './mock.json';
class Metadata extends BaseApi {
    constructor() {
        super('/metadata');
    }
    getById(id) {
        if (this.useMock) {
            return keysToCamel(mockMetadata);
        }
        return super.getById(id);
    }
    update(primaryId, payload) {
        if (this.useMock) {
            return true;
        }
        return super.update(primaryId, payload);
    }
}
const MetadataApi = new Metadata();
export default MetadataApi;
